import * as React from 'react';
import { css } from 'aphrodite';

import styles from './onboardingFormIconStyles';

export default class FinanceSVG extends React.PureComponent {
  render() {
    return (
      <svg
        className={css(styles.positioning)}
        width="20px"
        height="20px"
        viewBox="0 0 20 20"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        focusable="false"
      >
        <title>icon_finance</title>
        <defs />
        <g
          id="icon_finance"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <g id="credit-card" transform="translate(2.000000, 4.000000)" stroke="#757575" strokeWidth="1.6">
            <rect id="Rectangle-path" x="0" y="0" width="16" height="12" rx="1.6" />
            <path d="M0,3.875 L16,3.875" id="Shape" />
          </g>
        </g>
      </svg>
    );
  }
}
